import axios from "axios";

const clienteAxios = axios.create({
  //  baseURL: "http://localhost:4002/api/",
  //https://jback.neitor.com/
  baseURL: "https://backsafe.neitor.com/api/",
});

export default clienteAxios;
